import request from "./api";
import { getRestauranteIdSync, ensureRestauranteLoaded } from './services/selectedRestaurante';
import {
  CATEGORY_LIST_FAILURE,
  CATEGORY_LIST_REQUEST,
  // RESTAURANTEID removed - use selectedRestaurante helper
  CATEGORY_LIST_SUCCESS,
  ORDER_ADD_ITEM,
  ORDER_CLEAR,
  ORDER_CREATE_FAILURE,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_LIST_FAILURE,
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_QUEUE_FAILURE,
  ORDER_QUEUE_REQUEST,
  ORDER_QUEUE_SUCCESS,
  ORDER_REMOVE_ITEM,
  ORDER_SET_TYPE,
  PAYMENT_SET_TYPE,
  PRODUCT_LIST_FAILURE,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  SCREEN_SET_WIDTH,
  WHATSAPP_NUMBER_SET,
  PIXQRCODE_SET,
  LOYALTY_POINTS_REQUEST,
  LOYALTY_POINTS_SUCCESS,
  LOYALTY_POINTS_FAILURE,
  LOYALTY_POINTS_CLEAR,
  LOYALTY_CALCULATE_POINTS_REQUEST,
  LOYALTY_CALCULATE_POINTS_SUCCESS,
  LOYALTY_CALCULATE_POINTS_FAILURE,
} from "./constants";

export const setPaymentType = (dispatch, paymentType) => {
  return dispatch({
    type: PAYMENT_SET_TYPE,
    payload: paymentType,
  });
};

export const setOrderType = (dispatch, orderType) => {
  return dispatch({
    type: ORDER_SET_TYPE,
    payload: orderType,
  });
};

export const setWhatsAppNumber = (dispatch, whatsAppNumber) => {
  return dispatch({
    type: WHATSAPP_NUMBER_SET,
    payload: whatsAppNumber,
  });
};

export const setPixQrCode = (dispatch, pixQrCode) => {
  return dispatch({
    type: PIXQRCODE_SET,
    payload: pixQrCode,
  });
};

export const listCategories = async (dispatch) => {
  dispatch({ type: CATEGORY_LIST_REQUEST });
  try {
    let restauranteId = getRestauranteIdSync();
    if (!restauranteId) {
      const r = await ensureRestauranteLoaded();
      restauranteId = r?.ID || r?.id;
    }

    const { data } = await request.get("/secao?restauranteId=" + restauranteId);

    dispatch({ type: CATEGORY_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CATEGORY_LIST_FAILURE, payload: error.message });
  }
};

export const listProducts = async (dispatch, category) => {
  dispatch({ type: PRODUCT_LIST_REQUEST });
  try {
    let restauranteId = getRestauranteIdSync();
    if (!restauranteId) {
      const r = await ensureRestauranteLoaded();
      restauranteId = r?.ID || r?.id;
    }

    const { data } = await request.get(`/produto/get-by-section?secaoId=${category}&restauranteId=${restauranteId}`);
    return dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data });
  } catch (error) {
    return dispatch({ type: PRODUCT_LIST_FAILURE, payload: error.message });
  }
};

export const addToOrder = (dispatch, item) => {
  return dispatch({ type: ORDER_ADD_ITEM, payload: item });
};

export const removeFromOrder = (dispatch, item) => {
  return dispatch({ type: ORDER_REMOVE_ITEM, payload: item });
};

export const clearOrder = (dispatch) => {
  return dispatch({ type: ORDER_CLEAR });
};

export const createOrder = async (dispatch, order) => {
  dispatch({ type: ORDER_CREATE_REQUEST });
  try {
    const { data } = await request.post("/pedido", order);

    // Define o QR Code no estado se estiver presente na resposta
    if (data.qrCode) {
      setPixQrCode(dispatch, data.qrCode);
    }

    const pagou = await checkPaymentSuccess(data.pedidoId);

    if (!pagou) {
      await request.delete("/payment?pedidoId=" + data.pedidoId);
      throw new Error("Seu pedido não foi processado. Conclua o pedido no balcão.")
    }

    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data });
    dispatch({ type: ORDER_CLEAR });
    
    // Limpar localStorage quando pagamento é bem-sucedido
    console.log('[createOrder] Pagamento bem-sucedido - limpando localStorage');
    localStorage.removeItem('currentOrder');
    localStorage.removeItem('lastPaymentType');
  } catch (error) {
    console.log(error);

    let errorMessage = error.message;

    // Verificar se é um erro estruturado do backend
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message; 
    }
    // Check if it's the specific payment cancellation error
    else if (error.response && error.response.status === 400 &&
      error.response.data && error.response.data.includes("A solicitação de pagamento foi cancelada")) {
      dispatch({ type: ORDER_CREATE_FAILURE, payload: "PAYMENT_CANCELLED" });
      dispatch({ type: ORDER_CLEAR });
      return;
    }

    dispatch({ type: ORDER_CREATE_FAILURE, payload: errorMessage });
    dispatch({ type: ORDER_CLEAR });
  }
};

const checkPaymentSuccess = async (id) => {
  const startTime = Date.now();
  const timeout = 120 * 1000; // 1 minuto

  const poll = async () => {
    const elapsed = Date.now() - startTime;

    if (elapsed > timeout) {
      return false;
    }

    try {
      const response = await request.get("/payment?pedidoId=" + id);
      const isSuccess = response.data === true;

      if (isSuccess) {
        return true;
      } else {
        await new Promise((resolve) => setTimeout(resolve, 1000)); // espera 1s
        return await poll();
      }
    } catch (err) {
      console.error("Erro na requisição:", err);
      return false;
    }
  };

  return await poll();
};

export const listOrders = async (dispatch) => {
  dispatch({ type: SCREEN_SET_WIDTH });
  dispatch({ type: ORDER_LIST_REQUEST });
  try {
    const { data } = await request.get("/api/orders");
    return dispatch({ type: ORDER_LIST_SUCCESS, payload: data });
  } catch (error) {
    return dispatch({ type: ORDER_LIST_FAILURE, payload: error.message });
  }
};

export const listQueue = async (dispatch) => {
  dispatch({ type: ORDER_QUEUE_REQUEST });
  try {
    const { data } = await request.get("/api/orders/queue");
    dispatch({ type: ORDER_QUEUE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: ORDER_QUEUE_FAILURE, payload: err.message });
  }
};

// Programa de Fidelidade Actions
export const getLoyaltyPoints = async (dispatch, telefone) => {
  dispatch({ type: LOYALTY_POINTS_REQUEST });
  try {
    let restauranteId = getRestauranteIdSync();
    if (!restauranteId) {
      const r = await ensureRestauranteLoaded();
      restauranteId = r?.ID || r?.id;
    }
    const { data } = await request.get(`/api/ProgramaFidelidade/pontos?telefone=${telefone}&restauranteId=${restauranteId}`);
    console.log("getLoyaltyPoints - API response:", data);

    // A API retorna um objeto, precisamos extrair os pontos disponíveis
    const availablePoints = data.pontosDisponivel || data.pontosTotal || 0;

    console.log("getLoyaltyPoints - pontos disponíveis:", availablePoints);
    dispatch({ type: LOYALTY_POINTS_SUCCESS, payload: availablePoints });
    return availablePoints;
  } catch (error) {
    console.log("getLoyaltyPoints - erro:", error);
    dispatch({ type: LOYALTY_POINTS_FAILURE, payload: error.message });
    throw error;
  }
};

export const calculateOrderPoints = async (dispatch, order) => {
  dispatch({ type: LOYALTY_CALCULATE_POINTS_REQUEST });
  try {
    const { data } = await request.post("/Produto/calcular-pontos", order);
    console.log("calculateOrderPoints - API response:", data);

    // A API retorna { pontosNecessarios: number }, então precisamos extrair o valor
    const pointsNeeded = data.pontosNecessarios || data;

    dispatch({ type: LOYALTY_CALCULATE_POINTS_SUCCESS, payload: pointsNeeded });
    return pointsNeeded;
  } catch (error) {
    dispatch({ type: LOYALTY_CALCULATE_POINTS_FAILURE, payload: error.message });
    throw error;
  }
};

export const clearLoyaltyPoints = (dispatch) => {
  dispatch({ type: LOYALTY_POINTS_CLEAR });
};
